<div class="root container my-4">
  <div class="row">
    <div class="col-12 col-md-6 container">
      <div class="row">
        <h2 i18n class="col-12 font-weight-bolder">Create Account with Mobile</h2>
      </div>
      <iframe
        id="loginFrame"
        [src]="B2CSignUpPhone | safeUrl"
        frameborder="0"
        scrolling="no"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation-by-user-activation"
      >
      </iframe>
    </div>
  </div>
</div>
